export const REACT_APP_CHAINID = '0x3'
export const REACT_APP_ASTRO_TOKEN_ADDRESS = '0xBC44E944fCA8AeBEe92b329EbFba51cb574f69c6'
